import type { ValidationErrors } from '@frontend/utils';
import { FormParagraphFormGroupField } from '@frontend/components/fields/FormParagraphField';
import { translateKey } from '@frontend/translate';
import { InputTextField } from '../../../../../userDataManagement/InputText';
import { ServiceOrganizationSettingFormMode } from '../../ServiceOrganizationSetting';

interface IZorgmailNumberProps {
    errors?: ValidationErrors;
    mode: ServiceOrganizationSettingFormMode;
}

export function ZorgmailNummerField(props: IZorgmailNumberProps) {
    return (
        <>
            {props.mode === ServiceOrganizationSettingFormMode.read ? (
                <FormParagraphFormGroupField
                    fieldKey="zorgmailNummer"
                    label="serviceOrganizationSetting.zorgMailNumber"
                />
            ) : (
                <InputTextField
                    error={props.errors?.get('zorgmailNummer')}
                    fieldKey="zorgmailNummer"
                    hasErrors={props.errors?.has('zorgmailNummer')}
                    isRequired={false}
                    label="serviceOrganizationSetting.zorgMailNumber"
                    nullable={true}
                    placeholder={translateKey('serviceOrganizationSetting.zorgMailNumber')}
                />
            )}
        </>
    );
}
